import { IAIResponse } from '../../types/AI/IAIResponse';
import { IAITranslate } from '../../types/AI/IAITranslate';
import { Api } from './BaseApi'

const aiApi = Api.injectEndpoints({
    endpoints: (build) => ({
        getTicketSummary: build.query<IAIResponse, { ticketId: number }>({
            query: ({ ticketId }) => `AI/Ticket/${ticketId}/Summary`,
            providesTags: ["GetTicketAISummary"],
        }),
        translateNote: build.mutation<IAIResponse, IAITranslate>({
            query: (props) => ({
                url: `AI/Translate`,
                method: "POST",
                body: props
            }),
        })
    })
})

export { aiApi };